import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { EquipmentBattery, ListItem, RepositoryModal } from '../../shared'
import { EquipmentBatteryListComponent } from './equipment-battery-list.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    templateUrl: './equipment-battery-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class EquipmentBatteryModalComponent extends RepositoryModal<EquipmentBattery> {
    equipmentOptions: ListItem<string>[] = []

    protected onInitialized() {
        this.equipmentOptions = (this.editOptions.initializeParams as EquipmentBatteryListComponent).equipmentOptions
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        super.onSave(
            result => {
                ;(this.editOptions.initializeParams as EquipmentBatteryListComponent).parent.refresh()
                resolveSave(result)
            },
            rejectSave,
        )
    }
}
